import { defineMessages } from 'react-intl';

export const billingMessages = defineMessages({
  couldntStartCheckout: {
    defaultMessage: 'Couldn’t start checkout',
    id: 'kcCFA5Uz8J',
    description:
      'Toast title shown when a Stripe / add-on / Evidence checkout call fails to hand back a session URL. Shared across every checkout mutation.',
  },
});
